module.exports = __webpack_public_path__ + "img/vertical_6_5_5010.3c96636b.png";